/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CampaignStatus } from '../../models/campaign-status';
import { GetCampaignItemsResult } from '../../models/get-campaign-items-result';

export interface ApiCampaignsCampaignIdItemsGet$Params {
  campaignId: string;
  status?: CampaignStatus;
  cursor?: string;
  limit?: number;

/**
 * Space to act in. Omit to use the user's default space. Must be a space the user belongs to, otherwise the request is rejected.
 */
  'x-space-id'?: string;
}

export function apiCampaignsCampaignIdItemsGet(http: HttpClient, rootUrl: string, params: ApiCampaignsCampaignIdItemsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetCampaignItemsResult>> {
  const rb = new RequestBuilder(rootUrl, apiCampaignsCampaignIdItemsGet.PATH, 'get');
  if (params) {
    rb.path('campaignId', params.campaignId, {});
    rb.query('status', params.status, {});
    rb.query('cursor', params.cursor, {});
    rb.query('limit', params.limit, {});
    rb.header('x-space-id', params['x-space-id'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetCampaignItemsResult>;
    })
  );
}

apiCampaignsCampaignIdItemsGet.PATH = '/api/campaigns/{campaignId}/items';
